import React from 'react';
import { IIconProps } from './utils';

export const ChevronLeftDouble = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path d="M15 21.25L7.5 15L15 8.75M22.5 21.25L15 15L22.5 8.75" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" />
  </svg>
);
